import React from "react";

type Props = {
  position?: "top" | "center" | "bottom";
};

const Loader: React.FC<Props> = ({ position }) => {
  const bgPosition = position || "center";

  return <div className={`lightbox__slide-item-loader bg-${bgPosition}`} />;
};

export default Loader;
